<template>
    <div id="linkBox">
      <el-dialog
        id="linkDialog"
        :title=linkTitle
        center
        :append-to-body="true"
        :visible.sync="linkVisible.show"
        width="40%"
      >
        <div class="tableContentNew">
          <el-table :data="linkList"  style="width: 100%">
            <el-table-column prop="childProjectName" align="center" label='构件名称'></el-table-column>
            <el-table-column prop="monitorObjectName" align="center" label='参数'></el-table-column>
            <el-table-column  prop="measureNo" align="center" label='测点编号'></el-table-column>
            <el-table-column width="100" label="操作" align="center">
              <template slot-scope="scope">
                <el-button  size="mini" style="color: #D88704" type="text"
                           @click="preview(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>

    </div>
</template>

<script>
    export default {
        name: "linkDailog",
        props:{
            linkVisible:Object,
            linkTitle:String,
            linkList:Array,
            linkNum:Number,
        },
        data(){
            return{

            }
        },
        methods:{
            preview(info){
                if(this.linkNum===1){
                    this.setFoundation(info.childProjectId,info.measureNo,info.monitorObjectCode)
                }else{
                    this.setNew(info.childProjectId,info.measureNo,info.startDate,info.endDate)
                }

            },
        //    项目跳转
            setFoundation(id,measureNo,monitorObjectCode){
                if (id == null || id == 0) {
                    return;
                }
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.9)'
                });
                this.$axios.get('/api/monitor/model/decision/systemType?id=' + id).then(res => {
                    if(res.data.status===200){
                        let childProject = res.data.datas.values.childProject;
                        if (childProject != null) {
                            localStorage.setItem("mainId", childProject.id);
                            localStorage.setItem("systemType", childProject.systemType);
                            localStorage.setItem("url", "http://detect.scentralit.com:9095/image/");
                            if (childProject.systemType == "1") {//3D
                                localStorage.setItem("path", res.data.datas.values.bimViewToken)
                                localStorage.setItem("currentpoint", res.data.datas.values.childProject.childProjectType3d.modelView)
                                console.log({measureNo:measureNo,monitorObjectCode:monitorObjectCode})
                                this.$router.push({name: 'realTimeData',query:{measureNo:measureNo,monitorObjectCode:monitorObjectCode}});
                            } else {
                                localStorage.setItem("path", childProject.childProjectType2d.projectPicPath);
                                this.$router.push({name:'realTimeData2d'})
                            }
                        }
                        loading.close();
                    }else{
                        loading.close();
                    }

                }).catch(()=>{
                    loading.close();
                })
            },
            setNew(id,measureNo,startDate,endDate){
                if (id == null || id == 0) {
                    return;
                }
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.9)'
                });
                this.$axios.get('/api/monitor/model/decision/systemType?id=' + id).then(res => {
                    if(res.data.status===200){
                        let childProject = res.data.datas.values.childProject;
                        if (childProject != null) {
                            localStorage.setItem("mainId", childProject.id);
                            localStorage.setItem("systemType", childProject.systemType);
                            localStorage.setItem("url", "http://detect.scentralit.com:9095/image/");
                            if (childProject.systemType == "1") {//3D
                                localStorage.setItem("path", res.data.datas.values.bimViewToken)
                                localStorage.setItem("currentpoint", res.data.datas.values.childProject.childProjectType3d.modelView)
                                sessionStorage.setItem('isSelect','menu2')
                                this.$router.push({
                                    name: 'dataManage',
                                    query:{
                                        id:id,
                                        measureNo:measureNo,
                                        startDate:startDate.split(' ')[0],
                                        endDate:endDate.split(' ')[0],
                                    }
                                });
                            } else {
                                localStorage.setItem("path", childProject.childProjectType2d.projectPicPath);
                                this.$router.push({name:'realTimeData2d'})
                            }
                        }
                        loading.close();
                    }else{
                        loading.close();
                    }

                }).catch(()=>{
                    loading.close();
                })
            },

        }
    }
</script>

<style>
  #linkDialog .el-dialog__header{
    display:flex;
    flex-direction: row;
    justify-content: center;
  }
  #linkDialog .el-dialog {
    background:rgba(6,21,43,0.85);
  }
  #linkDialog .el-dialog__header{
    border: 1px solid #178Af4;
  }
  #linkDialog .el-dialog__title{
    font-size: 18px;
    font-weight: 800;
    text-align: center;
    word-spacing: 5px;
    color: #FFFFFF !important;
  }
  #linkDialog .el-dialog__headerbtn {
    background-color: #334560;
    padding: 2px 2px;
    color: #FFFFFF !important;
  }
  #linkDialog .el-dialog__body{
    border: 1px solid #178Af4;
    padding: 10px 10px !important;
  }
  .tableContentNew .el-table th,
  .tableContentNew .el-table tr {
    background: #152743 !important;
    font-size: 12px;
  }
  .tableContentNew .el-table__body tr:hover > td {
    background: #0C1B30 !important;

  }
  .tableContentNew .el-table--border:after,
  .tableContentNew .el-table--group:after,
  .tableContentNew .el-table:before {
    background-color: #0C1B30 !important;
  }
  .tableContentNew .el-table--border,
  .tableContentNew .el-table--group {
    border-color: #0C1B30 !important;

  }
  .tableContentNew .el-table td,
  .tableContentNew .el-table th.is-leaf {
    border-bottom: 1px solid rgba(255,255,255,0.15) !important;
  }
  .tableContentNew .el-table--border th,
  .tableContentNew .el-table--border th.gutter:last-of-type {
    border-bottom: 1px solid rgba(255,255,255,0.15) !important;
  }
  .tableContentNew .el-table--border td,
  .tableContentNew .el-table--border th {
    border-right: 1px solid rgba(255,255,255,0.15) !important;
  }



  .tableContentNew .has-gutter{
    color: #ffffff;

  }
  .tableContentNew{
    color: #ffffff;
  }
  .tableContentNew .el-table__empty-block{
    background-color: #061938 !important;
    width: 100% !important;
    text-align: center !important;
    color: #ffffff;
  }

  .tableContentNew .el-table__body tr.el-table__row--striped td{
    background-color: #061938 !important;
    color: #ffffff;
  }
  .tableContentNew  .el-table__body tr.el-table__row td{
    background-color:#061938 ;
    color: #ffffff;
  }


</style>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/linkDailog.vue